module.exports = __webpack_public_path__ + "static/img/LACHY-DOVASTON.8d86307.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LACHY-DOVASTON.jpg
// module id = GI3I
// module chunks = 0